<template>
  <div>
    <tooltip label="View" type="default" placement="left">
      <a class="button button-table is-small" @click="urlInvoice()">
        <i class="fa fa-eye"></i>
      </a>
    </tooltip>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import message from '../../utils/message'
  import Invoice from '../finances/invoice'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip,
      Invoice
    },
    methods: {
      view () {
        let propsData = {
          context: this,
          invoice_id: this.data.id,
          edit: false,
          callback: ''
        }
        Invoice.openInvoice(propsData)
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      },
      urlInvoice (result) {
        if (this.data.deadline > '2022-12-05') {
          window.open('https://ezlink.global/ezlink/api/V2/invoice/invoice_simple/' + this.data.customer_id + '/' + this.data.id)
        } else {
          window.open('https://ezlink.global/ezlink/api/invoice/invoice_simple/' + this.data.customer_id + '/' + this.data.id)
        }
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// InvoicesClientTableButtons.vue?f8dedcbc